<aero-form submitButtonLabel='Send Request'
           [showCancelButton]="false"
           (onSubmit)="sendRequest()">
  <aero-input [type]="'text'"
              [label]="'Auth URL'"
              [name]="'authUrl'"
              [placeholder]="'Platform Auth URL'"
              [required]="false"
              [(ngModel)]="authUrl">
  </aero-input>
  <aero-input [type]="'text'"
              [label]="'Names and Roles URL'"
              [name]="'requestUrl'"
              [placeholder]="'Platform Names and Roles URL'"
              [required]="false"
              [(ngModel)]="requestUrl">
  </aero-input>
  <aero-input [type]="'text'"
              [label]="'Our ClientId as registered with Platform'"
              [name]="'clientId'"
              [placeholder]="'clientId'"
              [required]="false"
              [(ngModel)]="clientId">
  </aero-input>
</aero-form>
<p>Response:</p>
<div style="outline: gray solid 2px; overflow: auto; height: 500px; width: 100%">
  <pre>{{response}}</pre>
</div>
